import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { PrintCommandDirective } from '../print-command.directive'
import { MatIcon } from '@angular/material/icon'
import { MatTooltip } from '@angular/material/tooltip'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-print-config-state',
  templateUrl: './print-config-state.component.html',
  styleUrls: ['./print-config-state.component.scss'],
  imports: [MatTooltip, MatIcon, AsyncPipe],
})
export class PrintConfigStateComponent {
  printCommand = inject(PrintCommandDirective, { optional: true })
}
